'use client';
import { useEffect } from 'react';

// VX L4-10 — 전역 오류 경계. 루트 layout 을 «대체» 하므로 전역 CSS·토큰이 없을 수 있다 →
//   클래스에 기대지 않고 인라인(토큰 참조 + 시스템 기본색 폴백)으로 선다. 글자 크기는 숫자(토큰이 없으면 var() 선언이 통째로 무효가 된다). 이모지 없음 · 다음 행동 안내.
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error('GlobalError:', error);
    try { import('@sentry/nextjs').then(Sentry => Sentry.captureException(error)); } catch {}
  }, [error]);

  return (
    <html lang="ko">
      <body style={{ margin: 0, fontFamily: 'var(--font-sans, sans-serif)', background: 'var(--bg-base, Canvas)', color: 'var(--text-primary, CanvasText)', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div role="alert" style={{ boxSizing: 'border-box', width: '100%', maxWidth: 520, margin: 16, padding: '20px 16px 16px', background: 'var(--card, Canvas)', border: '1px solid var(--line, GrayText)', borderRadius: 12, textAlign: 'left', wordBreak: 'keep-all' }}>
          <p style={{ margin: 0, fontSize: 12, fontWeight: 'var(--fw-title)', color: 'var(--gold-ink, CanvasText)' }}>일시 오류</p>
          <h1 style={{ margin: '10px 0 6px', fontSize: 22, lineHeight: 1.3, fontWeight: 'var(--fw-title)', color: 'var(--navy, CanvasText)' }}>화면을 그리지 못했습니다</h1>
          <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: 'var(--text-secondary, CanvasText)' }}>「다시 시도」를 누르면 같은 화면을 다시 불러옵니다. 계속 안 되면 홈으로 이동해 다시 들어와 주세요.</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 16 }}>
            <button onClick={reset} style={{ minHeight: 46, padding: '0 18px', borderRadius: 10, border: '1px solid var(--navy, ButtonText)', background: 'var(--navy, ButtonFace)', color: 'var(--on-navy, ButtonText)', fontSize: 15, fontWeight: 'var(--fw-title)', cursor: 'pointer' }}>
              다시 시도
            </button>
            {/* eslint-disable-next-line @next/next/no-html-link-for-pages -- global error boundary, router may be unavailable */}
            <a href="/" style={{ display: 'inline-flex', alignItems: 'center', minHeight: 46, padding: '0 18px', boxSizing: 'border-box', borderRadius: 10, border: '1px solid var(--line-2, GrayText)', color: 'var(--navy, LinkText)', fontSize: 15, fontWeight: 'var(--fw-title)', textDecoration: 'none' }}>홈으로 가기</a>
          </div>
          {error.digest && <p style={{ margin: '12px 0 0', fontSize: 12, color: 'var(--text-secondary, CanvasText)' }}>오류 코드 {error.digest}</p>}
        </div>
      </body>
    </html>
  );
}
